import api from "./axios";

const authApi = {
  // Admin
  loginAdmin: (email, password) =>
    api.post("/auth/admin/login", { email, password }),

  logout: () => api.post("/auth/logout"),

  me: () => api.get("/auth/me"),
};

export default authApi;
